import { useGridApiRef } from "@mui/x-data-grid";

import { isTestRunning } from "utils/misc/isTestRunning";

export const useResizeColumns = () => {
  const apiRef = useGridApiRef();

  const resizeColumns = () => {
    if (!apiRef.current || isTestRunning()) return;

    requestAnimationFrame(() => {
      if (!apiRef.current) return;

      apiRef.current.autosizeColumns({
        includeHeaders: true,
        includeOutliers: true,
        expand: true,
      });
    });
  };

  return { apiRef, resizeColumns };
};
